// extracted by mini-css-extract-plugin
export default {"lock":"RevisedClassRow_lock__FeVIc","locked":"RevisedClassRow_locked__GpV4+"};